(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saelg-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Loopet er pynt: ikke på sparedata/2G, og ikke hvis brugeren har bedt om mindre bevægelse.
  function maaLoope(){
    if(!('IntersectionObserver' in window)) return false;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if(c && (c.saveData || /2g$/.test(c.effectiveType || ''))) return false;
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function spil(v){ var p = v.play(); if(p && p.catch){ p.catch(function(){}); } }

  function wire(root){
    if(root.__mtwVideoWired) return;
    var preview = root.querySelector('[data-mtw-vpreview]');
    var openEls = root.querySelectorAll('[data-mtw-vopen]');
    var lb = root.querySelector('[data-mtw-vlb]');
    var full = root.querySelector('[data-mtw-vfull]');
    if(!lb || !full) return;
    root.__mtwVideoWired = true;
    var lastFocus = null;
    var iBillede = false;
    var fortsaetVed = 0;

    // Preview-filen hentes først, når sektionen er i billedet, og pauses igen uden for det.
    function styrLoop(){
      if(!preview) return;
      if(iBillede && lb.hidden){
        if(!preview.getAttribute('src')){ preview.src = preview.getAttribute('data-src'); }
        spil(preview);
      } else if(preview.getAttribute('src')){
        try{ preview.pause(); }catch(e){}
      }
    }
    if(preview && maaLoope()){
      // Plakaten ligger under, så en afvist autoplay (fx strømsparetilstand) bare ser ud som plakaten.
      preview.addEventListener('playing', function(){ preview.classList.add('is-klar'); });
      new IntersectionObserver(function(es){
        iBillede = es[es.length - 1].isIntersecting;
        styrLoop();
      }, { threshold: .25 }).observe(preview.parentNode);
    }

    function open(){
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      styrLoop();
      // Den fulde video hentes først her, i selve klikket (krævet for lyd på iOS).
      var plakat = full.getAttribute('data-poster');
      if(plakat && !full.getAttribute('poster')){ full.setAttribute('poster', plakat); }
      full.src = full.getAttribute('data-src');
      if(fortsaetVed > 0){
        var ved = fortsaetVed;
        full.addEventListener('loadedmetadata', function saet(){
          full.removeEventListener('loadedmetadata', saet);
          try{ full.currentTime = ved; }catch(e){}
        });
      }
      full.muted = false;
      spil(full);
      var closeBtn = lb.querySelector('button[data-mtw-vclose]');
      if(closeBtn) closeBtn.focus();
    }
    function close(){
      fortsaetVed = full.ended ? 0 : full.currentTime;
      try{ full.pause(); }catch(e){}
      // Slip filen helt, så en lukket video ikke bliver ved med at hente på mobildata.
      full.removeAttribute('src');
      full.load();
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      styrLoop();
      if(lastFocus && lastFocus.focus){ lastFocus.focus(); }
    }

    for(var i=0;i<openEls.length;i++){ openEls[i].addEventListener('click', open); }
    var closeEls = lb.querySelectorAll('[data-mtw-vclose]');
    for(var j=0;j<closeEls.length;j++){ closeEls[j].addEventListener('click', close); }
    document.addEventListener('keydown', function(e){ if(!lb.hidden && (e.key === 'Escape' || e.key === 'Esc')){ close(); } });
  }
  function initAll(){
    var nodes = document.querySelectorAll('[data-mtw-video]');
    for(var i=0;i<nodes.length;i++){ wire(nodes[i]); }
  }
  if(document.readyState !== 'loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saelg-why"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Skift thumbnail ud med den rigtige afspiller ved klik. Sektionen kan genindlæses i editoren,
  // så klikket lyttes på document (kun én gang, også hvis filen køres igen).
  if(window.__mtwYtLite) return;
  window.__mtwYtLite = true;
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var a = e.target.closest('[data-mtw-yt]');
    if(!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var start = a.getAttribute('data-start');
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(a.getAttribute('data-mtw-yt')) + '?autoplay=1&playsinline=1' + (start ? '&start=' + encodeURIComponent(start) : '');
    f.title = a.getAttribute('data-title') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    f.setAttribute('allowfullscreen', '');
    a.parentNode.replaceChild(f, a);
    f.focus();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
